<template>
  <BaseDialog
    :max-width="600"
    :propDialog="dialog"
    :title="$t('order.select-table')"
    :actionButton="$t('order.takeaway')"
    @confirm="selectTakeaway"
    @closeDialog="setDialog"
  >
    <TableList
      :tableList="tableList"
      @selectTable="selectTable"
      @changeTab="$emit('changeTab')"
    />
  </BaseDialog>
</template>

<script>
import TableList from './TableList'

export default {
  name: 'SelectTable',

  components: {
    TableList
  },

  props: {
    dialog: Boolean,
    tableList: Array
  },

  methods: {
    setDialog(val) {
      this.$emit('update:dialog', val)
    },

    selectTable(table) {
      this.$emit('selectTable', table)
      this.setDialog(false)
    },

    selectTakeaway() {
      this.$emit('selectTakeaway')
      this.setDialog(false)
    }
  }
}
</script>

<style scoped></style>
